import { ALLOW_RENDER } from '../../action-types/ui/allowRender';

export const STATE_KEY = 'allowRender';

export const allowRender = (state = true, action) => {
  switch (action.type) {
    case ALLOW_RENDER:
      return action.allow;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/ui/allowRender.js